import React, { useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios';
import { getToken } from '../config/services/token'

export default function SetUsername() {
    const UrlParams = useParams()
    const navigate = useNavigate()
    let { id } = UrlParams

    let fetchToken = async () => {
        let tokenObj = await getToken()
        return tokenObj?.data?.token
    }

    useEffect(() => {
        localStorage.setItem('username', id)
        fetchToken()
            .then(async token => {
                localStorage.setItem('accessToken', token)
                axios.interceptors.request.use(
                    (request) => {
                        request.headers['accessToken'] = token;
                        return request;
                    }
                )
                navigate('/embedDashboard/615ed21382b87f002af1465f')
            })
    }, [])

    return (
        <>
            Redirecting.....
        </>
    );
}